module.exports = __webpack_public_path__ + "static/media/btg.11a0301a.svg";